import React, { useState } from "react";
import MainCalculatorsList from "./MainCalculators";
import RelatedLinks from "../RelatedLinks";
import { FirstAds, SecondAds, MobileUnderCalAds } from "../../Ads";
import SharedHelmet from "../Helmet";

const TITLE = "Kalkulator Perbedaan Antara Dua Tanggal atau Usia dalam Hijriah";
const DESCRIPTION =
  "Hitung periode antara dua tanggal dalam Hijriah dengan akurat. Kalkulator menampilkan perbedaan dalam tahun, bulan, hari, jam, menit, dan detik, dengan informasi tambahan yang detail.";
const KEYWORDS =
  "Hitung perbedaan antara dua usia hijriah, hitung perbedaan antara dua tanggal hijriah, kalkulator perbedaan waktu hijriah, perbedaan antara dua tanggal dalam hijriah, perhitungan usia hijriah";
const OG_URL = "https://do-calculate.com/calculator/id/datehijridifferences/";

// Nama bulan Hijriah
const HIJRI_MONTHS = [
  "Muharram", "Safar", "Rabiul Awal", "Rabiul Akhir", "Jumadil Awal", "Jumadil Akhir",
  "Rajab", "Sya'ban", "Ramadhan", "Syawal", "Dzulqa'dah", "Dzulhijjah"
];

function DateDifferencesCalculatorHijri() {
  const [d1, setD1] = useState({ day: "1", month: "1", year: "1445" });
  const [d2, setD2] = useState({ day: "1", month: "1", year: "1446" });
  const [differences, setDifferences] = useState(null);
  const [error, setError] = useState(null);
  const [isLoading, setIsLoading] = useState(false);

  const calculateDifferences = () => {
    setIsLoading(true);
    setError(null);

    // Konversi input ke angka
    let day1 = parseInt(d1.day), month1 = parseInt(d1.month), year1 = parseInt(d1.year);
    let day2 = parseInt(d2.day), month2 = parseInt(d2.month), year2 = parseInt(d2.year);

    // Urutkan tanggal (yang lebih kecil terlebih dahulu)
    let start = { y: year1, m: month1, d: day1 };
    let end = { y: year2, m: month2, d: day2 };

    if (year1 > year2 || (year1 === year2 && month1 > month2) || (year1 === year2 && month1 === month2 && day1 > day2)) {
      start = { y: year2, m: month2, d: day2 };
      end = { y: year1, m: month1, d: day1 };
    }

    // Hitung perbedaan Hijriah (perkiraan)
    let diffYears = end.y - start.y;
    let diffMonths = end.m - start.m;
    let diffDays = end.d - start.d;

    if (diffDays < 0) {
      diffMonths--;
      diffDays += 30; // Bulan Hijriah biasanya 29 atau 30 hari
    }
    if (diffMonths < 0) {
      diffYears--;
      diffMonths += 12;
    }

    // Hitung statistik (perkiraan untuk kalender Hijriah: tahun Hijriah ≈ 354.36 hari)
    const totalDays = Math.floor(diffYears * 354.36 + diffMonths * 29.53 + diffDays);
    const totalHours = totalDays * 24;
    const totalMinutes = totalHours * 60;
    const totalSeconds = totalMinutes * 60;

    setDifferences({
      years: diffYears,
      months: diffMonths,
      days: diffDays,
      totalDays,
      totalWeeks: Math.floor(totalDays / 7),
      totalMonths: diffYears * 12 + diffMonths,
      totalHours,
      totalMinutes,
      totalSeconds,
      startDate: `${start.d} ${HIJRI_MONTHS[start.m - 1]} ${start.y}`,
      endDate: `${end.d} ${HIJRI_MONTHS[end.m - 1]} ${end.y}`,
      workDays: Math.floor((totalDays / 7) * 5)
    });

    setIsLoading(false);
  };

  const renderSelectGroup = (data, setData, label) => (
    <div className="mb-4">
      <label ><strong>{label}:</strong></label>
      <div className="row">
        <div className="col-md-4">
          <select className="form-control" value={data.day} onChange={(e) => setData({ ...data, day: e.target.value })}>
            {Array.from({ length: 30 }, (_, i) => i + 1).map(d => <option key={d} value={d}>{d}</option>)}
          </select>
        </div>
        <div className="col-md-4">
          <select className="form-control" value={data.month} onChange={(e) => setData({ ...data, month: e.target.value })}>
            {HIJRI_MONTHS.map((m, i) => <option key={i + 1} value={i + 1}>{i + 1} - {m}</option>)}
          </select>
        </div>
        <div className="col-md-4">
          <select className="form-control" value={data.year} onChange={(e) => setData({ ...data, year: e.target.value })}>
            {Array.from({ length: 100 }, (_, i) => 1500 - i).map(y => <option key={y} value={y}>{y}</option>)}
          </select>
        </div>
      </div>
    </div>
  );

  return (
    <div className="ltr" style={{ direction: "rtl", textAlign: "right" }}>
      <SharedHelmet TITLE={TITLE} DESCRIPTION={DESCRIPTION} KEYWORDS={KEYWORDS} OG_URL={OG_URL} />

      <div className="row">
        <div className="col-12 col-md-8">
          <FirstAds />
          <br />
          <div className="bg-success text-white text-center p-3 rounded shadow-sm">
            <h1 style={{ fontSize: "20px", margin: 0 }}>{TITLE}</h1>
          </div>

          <div className="border border-light mt-3 p-3 bg-white shadow-sm">
            <p className="mb-4">
              Kalkulator ini khusus untuk menghitung perbedaan antara dua tanggal dalam <strong>kalender Hijriah</strong>. Masukkan kedua tanggal di bawah ini untuk mendapatkan hasil dalam tahun, bulan, hari, dan menit.
            </p>
            <hr />
            <MobileUnderCalAds />

            <div className="calculatorStyle mb-4 p-3 bg-light rounded border">
              <div className="p-2 mb-4 bg-success text-white text-center rounded">
                <strong>Masukkan Tanggal dalam Hijriah</strong>
              </div>

              {renderSelectGroup(d1, setD1, "Tanggal Hijriah Pertama")}
              {renderSelectGroup(d2, setD2, "Tanggal Hijriah Kedua")}

              <div className="text-center mt-4">
                <button className="btn btn-success btn-lg px-5" onClick={calculateDifferences} disabled={isLoading}>
                  {isLoading ? "Menghitung..." : "Hitung Perbedaan Sekarang"}
                </button>
              </div>

              {error && <div className="alert alert-danger mt-3">{error}</div>}

              {differences && (
                <div className="mt-5 animate__animated animate__fadeIn">
                  <div className="alert alert-success border-success">
                    <h3 style={{ fontSize: "18px" }}><strong>Hasil Perhitungan Perbedaan Antara Dua Tanggal Hijriah:</strong></h3>
                    <div className="p-3 bg-white rounded border mt-3 text-center">
                      <strong className="text-muted">Perbedaannya adalah:</strong>
                      <div style={{ fontSize: "24px", color: "#28a745", fontWeight: "bold" }}>
                        {differences.years} tahun {differences.months} bulan {differences.days} hari
                      </div>
                    </div>
                  </div>

                  <div className="row">
                    <div className="col-md-6 mb-3">
                      <div className="card h-100 shadow-sm">
                        <div className="card-header bg-success text-white"><strong>Perbedaan Detail Hijriah</strong></div>
                        <div className="card-body">
                          <ul className="list-unstyled lh-lg">
                            <li>✓ Tahun Hijriah: {differences.years}</li>
                            <li>✓ Bulan Hijriah: {differences.months}</li>
                            <li>✓ Hari: {differences.days}</li>
                            <li>✓ Jam: {differences.totalHours.toLocaleString()}</li>
                          </ul>
                        </div>
                      </div>
                    </div>

                    <div className="col-md-6 mb-3">
                      <div className="card h-100 shadow-sm">
                        <div className="card-header bg-success text-white"><strong>Statistik Total</strong></div>
                        <div className="card-body">
                          <ul className="list-unstyled lh-lg">
                            <li>📅 Total Hari: {differences.totalDays.toLocaleString()} hari</li>
                            <li>📅 Total Minggu: {differences.totalWeeks.toLocaleString()} minggu</li>
                            <li>📅 Total Bulan: {differences.totalMonths.toLocaleString()} bulan</li>
                            <li>⏰ Total Jam: {differences.totalHours.toLocaleString()} jam</li>
                            <li>⏰ Total Menit: {differences.totalMinutes.toLocaleString()} menit</li>
                            <li>💼 Perkiraan Hari Kerja: {differences.workDays.toLocaleString()} hari</li>
                          </ul>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div className="card mb-3 shadow-sm border-0 bg-light">
                    <div className="card-body text-center">
                      <p className="mb-1"><strong>Dari:</strong> {differences.startDate} H</p>
                      <p className="mb-0"><strong>Sampai:</strong> {differences.endDate} H</p>
                    </div>
                  </div>
                </div>
              )}
            </div>
            <hr />
            <RelatedLinks />
          </div>
        </div>

        <div className="col-md-4">
          <SecondAds />
          <MainCalculatorsList />
        </div>
      </div>
      <div className="row" style={{ height: "auto" }}>
        <div className="col-12 col-md-8">
          <div className="info-sections-container">
            <div className="info-section">
              <div className="info-section-header">
                Perbedaan Antara Dua Tanggal dalam Kalender Masehi: Menghitung Perbedaan Usia Antara Dua Orang
              </div>
              <div className="info-section-body">
                <u>
                  <h2 style={{ fontSize: "16px" }}>
                    {" "}
                    Usia dalam Tanggal Hijriah: Konversi dan Perhitungan Akurat{" "}
                  </h2>{" "}
                </u>
                <p>
                  Usia adalah aspek penting dalam kehidupan manusia, yang mencerminkan pengalaman dan kematangannya seiring berjalannya waktu. Menghitung perbedaan antara dua tanggal dalam kalender Masehi memerlukan pengetahuan yang akurat tentang tanggal dan kemampuan untuk mengkonversinya menjadi perbedaan waktu yang sederhana. Dalam artikel ini, kita akan melihat bagaimana menghitung perbedaan usia antara dua orang atau antara tanggal tertentu dalam kalender Masehi.
                </p>
                <hr />
                <u>
                  <h2 style={{ fontSize: "16px" }}>
                    {" "}
                    Konsep Dasar Menghitung Perbedaan Usia
                  </h2>{" "}
                </u>
                <p>
                  Menghitung perbedaan usia adalah proses menentukan jumlah tahun, bulan, dan hari yang memisahkan antara dua tanggal tertentu dalam kalender Masehi. Perhitungan ini dapat digunakan dalam banyak konteks seperti menghitung perbedaan usia antara dua orang, atau mengetahui perbedaan tahun antara tanggal penting seperti kelulusan, atau acara lainnya.
                </p>
                <hr />
                <u>
                  <h2 style={{ fontSize: "16px" }}>
                    {" "}
                    Cara Menghitung Perbedaan Usia Antara Tanggal Lahir
                  </h2>{" "}
                </u>
                Untuk menghitung perbedaan usia antara tanggal lahir tertentu dalam kalender Masehi, Anda dapat mengikuti langkah-langkah berikut:
                <ul>
                  <li>
                    Menentukan tanggal: Mulailah dengan menentukan tanggal yang ingin Anda hitung perbedaannya.
                  </li>
                  <li>
                    Mengkonversi tanggal menjadi hari: Konversikan setiap tanggal menjadi jumlah hari dengan mudah. Misalnya, Anda dapat mengkonversi setiap tanggal menjadi jumlah hari dari awal kalender.
                  </li>
                  <li>
                    Menghitung perbedaan: Kurangi jumlah hari satu dari yang lain untuk mendapatkan perbedaan usia dalam hari.
                  </li>
                  <li>
                    Mengkonversi perbedaan usia: Perbedaan usia dalam hari dapat dikonversi menjadi bulan atau tahun dengan membagi dengan jumlah hari dalam bulan atau tahun. Sebagai contoh, ada sekitar 30 hari dalam sebulan.
                  </li>
                </ul>
                <hr />
                <u>
                  <h2 style={{ fontSize: "16px" }}>
                    {" "}
                    Penggunaan Perhitungan Perbedaan Usia{" "}
                  </h2>{" "}
                </u>
                <p>
                  Perhitungan perbedaan usia dapat digunakan dalam banyak konteks seperti menghitung perbedaan usia antara dua orang dalam suatu hubungan, atau untuk menentukan perbedaan tahun antara tanggal penting seperti tanggal pernikahan atau tanggal pindah ke rumah baru. Juga dapat digunakan dalam aspek administrasi dan statistik.
                </p>
                <hr />
                <u>
                  <h2 style={{ fontSize: "16px" }}>
                    {" "}
                    Cara Menggunakan Kalkulator Perbedaan Antara Dua Usia atau Tanggal dalam Kalender Hijriah{" "}
                  </h2>{" "}
                </u>
                <p>
                  Penggunaan kalender Hijriah untuk menghitung usia manusia berasal dari sejarah Islam. Kalender Hijriah didasarkan pada hijrah Nabi Muhammad SAW dari Mekah ke Madinah pada tahun 622. Tahun Hijriah terdiri dari 12 bulan, dan jumlah hari setiap bulan bervariasi menurut kalender Hijriah. Tahun Hijriah lebih pendek dari tahun Masehi, sehingga tanggalnya berbeda dalam kedua tahun. <br />
                </p>
                <p>
                  Kalkulator ini bertujuan untuk menghitung perbedaan antara dua tanggal dalam kalender Hijriah. Dua tanggal dimasukkan ke dalam kalkulator sebagai tanggal Hijriah, seperti tanggal lahir dan tanggal hari ini. <br />
                </p>
                <p>
                  Saat dijalankan, kalkulator membandingkan kedua tanggal dan menghitung perbedaan dalam tahun, bulan, hari, jam, menit, dan detik di antara keduanya. Setelah selesai, Anda akan mendapatkan nilai yang mewakili perbedaan dalam setiap satuan waktu. <br />
                </p>
              </div>
            </div>
          </div>
          <br />
          <u>
            {" "}
            <h2>Pertanyaan Umum</h2>
          </u>
          <br />
          <div className="info-sections-container">
            <div className="info-section">
              <div className="info-section-header">
                <h3 style={{ fontSize: "16px" }}>
                  Apa itu perhitungan perbedaan antara dua usia dalam kalender Hijriah?
                </h3>
              </div>
              <div className="info-section-body">
                Perhitungan perbedaan antara dua usia dalam kalender Hijriah adalah proses menentukan perbedaan waktu antara tanggal lahir orang-orang tersebut dalam kalender ini. Perbedaan ini bisa dalam tahun, bulan, dan hari.
              </div>
            </div>
            <div className="info-section">
              <div className="info-section-header">
                <h3 style={{ fontSize: "16px" }}>
                  Bagaimana cara menghitung perbedaan antara dua usia dalam kalender Hijriah?
                </h3>
              </div>
              <div className="info-section-body">
                Anda dapat menghitung perbedaan antara dua usia atau tanggal dalam kalender Hijriah dengan mengikuti langkah-langkah berikut:
                <ol>
                  <li>
                    Menentukan tanggal lahir kedua orang atau tanggal yang ingin Anda hitung perbedaannya.
                  </li>
                  <li>
                    Mengkonversi tanggal tersebut ke tanggal Hijriah menggunakan tabel konversi atau alat yang tersedia online.
                  </li>
                  <li>Kurangi tanggal Hijriah untuk mendapatkan perbedaan dalam hari.</li>
                  <li>Konversikan perbedaan dalam hari menjadi tahun dan bulan jika Anda mau.</li>
                </ol>
              </div>
            </div>
            <div className="info-section">
              <div className="info-section-header">
                <h3 style={{ fontSize: "16px" }}>
                  Apakah ada kalkulator untuk menghitung perbedaan antara dua usia dalam kalender Hijriah?
                </h3>
              </div>
              <div className="info-section-body">
                Ya, Anda dapat menemukan kalkulator online yang membantu Anda menghitung perbedaan antara dua tanggal dalam kalender Hijriah dengan cepat dan sederhana. Yang perlu Anda lakukan adalah memasukkan tanggal Hijriah dan Anda akan mendapatkan perbedaan dengan akurat.
              </div>
            </div>
            <div className="info-section">
              <div className="info-section-header">
                <h3 style={{ fontSize: "16px" }}>
                  Apa pentingnya menghitung perbedaan antara dua usia dalam kalender Hijriah?
                </h3>
              </div>
              <div className="info-section-body">
                Menghitung perbedaan antara dua usia atau tanggal dalam kalender Hijriah dapat berguna dalam banyak konteks. Anda dapat mengetahui perbedaan antara usia orang atau mengetahui rentang waktu antara acara penting seperti pernikahan atau untuk tujuan lainnya.
              </div>
            </div>
            <div className="info-section">
              <div className="info-section-header">
                <h3 style={{ fontSize: "16px" }}>
                  Bisakah perbedaan antara dua usia dalam kalender Hijriah dihitung secara manual?
                </h3>
              </div>
              <div className="info-section-body">
                Ya, perbedaan antara dua usia dalam kalender Hijriah dapat dihitung secara manual dengan mengetahui tanggal Hijriah dan menggunakan aturan Masehi yang dikenal. Ini membutuhkan sedikit waktu dan usaha, tetapi secara teknis memungkinkan.
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
export default DateDifferencesCalculatorHijri;